import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class menuList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        return (
            <SelectorGrid
                loading={this.props.isLoading}
                componentConfig={this.props.componentConfig}
                view="list"
                columns={{
                    [this.props.componentConfig.idfield]: {
                        width: 1,
                        sortable,
                        filterable
                    },
                    "token": {
                        header: 'Token',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "label": {
                        header: 'Név',
                        width: 2,
                        sortable,
                        filterable
                    },
                }}
                pageSize={5}
                orderBy={{field: this.props.componentConfig.idfield, direction: "DESC"}}
                selection={this.props.selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default menuList;
